import React from 'react'
import { StyledInnerDiv, StyledOuterDiv } from './style'

interface IProps {
  children: React.ReactNode
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const PageContainer = ({ children }: IProps) => {
  return (
    <StyledOuterDiv>
      <StyledInnerDiv>
        {children}
      </StyledInnerDiv>
    </StyledOuterDiv>
  )
}

export default PageContainer
